import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../../../common/apiClient'

// The roster checks the signed-in account, including while using View As.
// Key its shared navigation result by that account, never the viewed profile.
export function useShutdownRosterAccess(email?: string) {
  const actor = email?.trim().toLowerCase()
  const query = useQuery({
    queryKey: ['shutdown-roster-access', actor],
    enabled: Boolean(actor),
    queryFn: () =>
      apiClient.get<{ canAccess: boolean; canEdit: boolean; canViewCompany: boolean; canConfigure: boolean }>('/api/shutdown-roster/access'),
    staleTime: 300_000,
    refetchOnWindowFocus: false,
    retry: false,
  })
  return {
    ...query,
    canAccess: Boolean(actor) && query.data?.canAccess === true,
    canEdit: Boolean(actor) && query.data?.canEdit === true,
    canViewCompany: Boolean(actor) && query.data?.canViewCompany === true,
  }
}
